import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const SkeletonGuidanceCard = () => {
  return (
    <SkeletonTheme baseColor="#ddd" highlightColor="#eee">
      <div className='NewsCard relative overflow-hidden rounded-[1.5rem] border border-[#D4DEF1] bg-white shadow-custom'>
        <div className="NewsCardMain flex flex-col gap-4 p-4 lg:flex-row lg:items-center">
          <div className="NewsCard__left w-full lg:w-[12rem] lg:flex-none">
            <Skeleton width="100%" height={128} borderRadius={20} />
          </div>
          <div className="NewsCard__leftRight min-w-0 flex-1 lg:pr-4">
            <div className="mb-2">
              <Skeleton width="85%" />
              <Skeleton width="65%" />
            </div>
            <p className='mb-2'>
              <Skeleton count={2} />
            </p>
            <p className='mb-2'>
              <Skeleton width="40%" />
            </p>
            <p>
              <Skeleton width="70%" />
            </p>
          </div>
          <div className="flex flex-row items-center justify-between gap-3 border-t border-[#EEF2F7] pt-4 lg:w-[10rem] lg:flex-col lg:items-end lg:justify-center lg:border-t-0 lg:pt-0 status-button">
            <Skeleton width={70} height={20} />
            <Skeleton width={78} height={36} borderRadius={999} />
          </div>
        </div>
      </div>
    </SkeletonTheme>
  );
};

export default SkeletonGuidanceCard;
